import React from 'react'
import {tv, type VariantProps} from 'tailwind-variants'
import {HgTableBodyCell} from '~/design-system/hg/components/HgTable'
import {type HgPricingTableRowContentCell} from '../types'

const hgPricingCellVariants = tv({
  slots: {
    cellWrapper:
      'h-full w-full min-w-[140px] p-0 text-text-default sm:min-w-[156px] md:max-w-[288px] md:p-0 md:pb-s6 md:pt-s3',
    content: 'items-start',
    innerTextContent: '',
    innerTextBody: '',
  },
  variants: {
    variant: {
      rowTitle: {
        cellWrapper:
          'col-span-2 text-left md:col-span-1 [&_a]:decoration-border-subdued',
        innerTextBody: 'has-[a.underline]:mb-s1',
      },
      bodyRow: {
        content: 'text-left md:justify-center md:text-center',
        innerTextContent: 'md:items-center',
      },
    },
    oneColumn: {
      true: {cellWrapper: 'col-span-1'},
    },
    isHeader: {
      true: {cellWrapper: 'py-s3 md:pt-s6'},
    },
  },
  compoundVariants: [
    {
      variant: ['bodyRow'],
      oneColumn: true,
      class: {content: 'justify-end text-right', innerTextContent: 'items-end'},
    },
  ],
})

const HgPricingTableCell: React.FC<{
  cell: HgPricingTableRowContentCell
  variant?: VariantProps<typeof hgPricingCellVariants>['variant']
  oneColumn?: boolean
}> = ({cell, variant, oneColumn = false}) => {
  const {cellWrapper, content, innerTextContent, innerTextBody} =
    hgPricingCellVariants({
      variant,
      oneColumn,
    })

  return (
    <HgTableBodyCell
      classNames={{
        cell: cellWrapper(),
        content: content(),
        innerTextContent: innerTextContent(),
        innerTextBody: innerTextBody(),
      }}
      {...cell}
    />
  )
}

export default HgPricingTableCell
